






























import { Component, Prop, Vue } from "vue-property-decorator";

import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconArrowRight3sticksType2 from "@/common/components/icons/IconArrowRight3sticksType2.vue";

import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";

@Component({
  components: {
    IconUserImage,
    IconBase,
    IconArrowRight3sticksType2
  }
})
export default class HDeliveryDetails extends Vue {
  @Prop({ type: [String, Boolean], default: false }) to!: string | boolean;
  @Prop({ type: [String, Boolean], default: false }) from!: string | boolean;

  get isSpScreenWidth() {
    return globals?.isSpScreenWidth;
  }

  get arrowIconColor() {
    return commons?.colorCode;
  }

  get recipientIconSize() {
    return this.isSpScreenWidth ? 74 : 135;
  }

  get senderIconSize() {
    return this.isSpScreenWidth ? 36 : 64;
  }

  get arrowSize() {
    return this.isSpScreenWidth
      ? {
          width: 18,
          height: 12
        }
      : {
          width: 34,
          height: 22
        };
  }
}
